"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
const Less_1 = require("./Less");
const Equal_1 = require("./Equal");
const Greater_1 = require("./Greater");
var Result;
(function (Result) {
    function is(result) {
        return result === Less_1.Less || result === Greater_1.Greater || result === Equal_1.Equal;
    }
    Result.is = is;
    function fromSortResult(sortResult) {
        if (sortResult === 0) {
            return Equal_1.Equal;
        }
        else if (sortResult < 0) {
            return Less_1.Less;
        }
        return Greater_1.Greater;
    }
    Result.fromSortResult = fromSortResult;
})(Result = exports.Result || (exports.Result = {}));
